import React, { Component } from "react";
import { connect } from "react-redux";
import { fetchCategories, fetchMed } from "Thunks";
import { setFilter } from "Actions";
import CategoriesComponent from "./CategoriesComponent";

export class Categories extends Component {
  componentDidMount() {
    const { fetchCategories } = this.props;

    fetchCategories();
  }

  handleApplyCategory = (categoryId, e) => {};

  render() {
    return (
      <CategoriesComponent
        applyCategory={this.handleApplyCategory}
        {...this.props}
      />
    );
  }
}
// Connected Component
const mapStateToProps = state => ({
  filter: state.filter.filterState,
  categories: state.categories.items,
  fetching: state.categories.fetching,
  lng: state.params.lng
});

const mapDispatchToProps = dispatch => ({
  fetchCategories: sort => dispatch(fetchCategories(sort)),
  fetchMedias: params => dispatch(fetchMed(params)),
  setFilter: filter => dispatch(setFilter(filter))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Categories);



// WEBPACK FOOTER //
// ./src/components/Community/Header/Categories/index.js